export const menuItems = [
  {
    path: "/",
    text: "home",
  },
  {
    path: "/chi-siamo",
    text: "chi siamo",
  },
  {
    path: "/decolli",
    text: "dove decolliamo",
  },
  {
    path: "/news",
    text: "news",
  },
  {
    path: "/contatti",
    text: "contatti",
  },
]
